import { TourActions } from './tour-actions'
import { TourBadge } from './tour-badge'
import { TourBody } from './tour-body'
import { TourButton } from './tour-button'
import { TourContent as TourContentBase } from './tour-content'
import { TourDescription } from './tour-description'
import { TourFooter } from './tour-footer'
import { TourHeader } from './tour-header'
import { TourHighlight } from './tour-highlight'
import { TourProgress } from './tour-progress'
import { TourTitle } from './tour-title'

// Compound component with all sub-components
export const TourContent = Object.assign(TourContentBase, {
  Header: TourHeader,
  Body: TourBody,
  Footer: TourFooter,
  Title: TourTitle,
  Description: TourDescription,
  Highlight: TourHighlight,
  Badge: TourBadge,
  Button: TourButton,
  Actions: TourActions,
  Progress: TourProgress,
})

// Export individual components for flexibility
export {
  TourActions,
  TourBadge,
  TourBody,
  TourButton,
  TourDescription,
  TourFooter,
  TourHeader,
  TourHighlight,
  TourProgress,
  TourTitle,
}

// Export types
export type { TourContentProps, TourButtonProps } from './tour-variants'
